import PropTypes from 'prop-types';

import { MENTION_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { Styled } from './Mention.style';

// @ts-expect-error Leftover after Brewery migration
const Mention = ({ className, ...attributes }) => {
  const RenderLeaf = ({
    // @ts-expect-error Leftover after Brewery migration
    children,
    // @ts-expect-error Leftover after Brewery migration
    element: { type, children: elChildren },
    // @ts-expect-error Leftover after Brewery migration
    attributes: elementAttributes,
  }) => {
    return type === MENTION_DEFINITIONS.type ? (
      <Styled.EditorMention
        {...attributes}
        {...elementAttributes}
        className={className}
        contentEditable={false}
        data-editor-plugin={MENTION_DEFINITIONS.type}
      >
        {children}
        {/* @ts-expect-error Leftover after Brewery migration */}
        {elChildren?.map((child) => child.text)}
      </Styled.EditorMention>
    ) : null;
  };
  return RenderLeaf;
};

Mention.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export { Mention };
